import React, { useEffect, useState } from "react";
import SEO from "../components/SEO";
import API_BASE_URL from "../api";

const AdmitCards = () => {
  const [admitCards, setAdmitCards] = useState([]);

  useEffect(() => {
    fetch(`${API_BASE_URL}/api/admit-cards`)
      .then((res) => res.json())
      .then((data) => setAdmitCards(Array.isArray(data) ? data : []))
      .catch((err) => {
        console.error("Error fetching admit cards:", err);
        setAdmitCards([]);
      });
  }, []);

  // Helper to format Oracle DATE / TIMESTAMP to dd/mm/yyyy
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return isNaN(date) ? "N/A" : date.toLocaleDateString("en-IN");
  };

  return (
    
    <><SEO
      title="Latest Admit Cards 2026"
      description="Download Latest Government Exam Admit Cards."
      keywords="admit card, hall ticket"
      url="https://sarkaricareerinfo.com/admit-card" />
      
      <div className="equal-width-section page-container">
        {/* Page Title */}
        <h2 className="page-title">Latest Admit Cards</h2>

        {admitCards.length === 0 ? (
          <p className="no-data">No Admit Cards Available</p>
        ) : (
          <div className="table-wrapper">
            <table className="jobs-table">
              <thead>
                <tr>
                  <th>Exam Name</th>
                  <th>Organization</th>
                  <th>Exam Date</th>
                  <th>Download Admit Card</th>
                </tr>
              </thead>
              <tbody>
                {admitCards.map((card, index) => (
                  <tr key={index}>
                    <td data-label="Exam Name">{card.admit_name || "N/A"}</td>
                    <td data-label="Organization">{card.organization || "N/A"}</td>
                    <td data-label="Exam Date">{formatDate(card.exam_date)}</td>
                    {/* <td data-label="Admit Card Link">
                      {card.download_link ? (
                        <a
                          href={card.download_link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="details-link"
                        >
                          Link
                        </a>
                      ) : (
                        "N/A"
                      )}
                    </td> */}
                    <td data-label="Action" className="col-action">
                      <a
                        href={card.download_link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn-details"
                      >
                        Download Link
                      </a>
                    </td>

                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div></>
  );
};

export default AdmitCards;

